import { Button, FormControlLabel, styled, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';

export const RecoverPasswordHint = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.p050};
  line-height: 18px;
`;

export const LinkW = styled(NavLink)`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.info.main};
  cursor: pointer;
  text-decoration: none;
`;

export const ButtonW = styled(Button)`
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  text-transform: none;
  width: 265px;
  padding: 14px 16px;
`;

export const RememberMeLabel = styled(FormControlLabel)`
  margin-left: -9px;

  .MuiFormControlLabel-label {
    font-size: 15px;
    color: ${({ theme }) => theme.palette.primary.p080};
  }
`;

export const LoginButton = styled(Button)`
  width: 100%;
  height: 50px;
  border-radius: 4px;
  font-weight: 400;
  font-size: 18px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  box-shadow: none;

  &:hover {
    box-shadow: none;
  }
`;

export const SignUpHint = styled(Typography)`
  font-size: 15px;
  color: ${({ theme }) => theme.palette.primary.p080};

  @media (min-width: 1023px) {
    padding-bottom: 24px;
  }
`;

export const SupportRow = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const SupportIcon = styled('div')`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: ${({ theme }) => theme.palette.primary.main};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    filter: brightness(0) invert(1);
    width: 20px;
    height: 20px;
  }
`;

export const SupportLink = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  text-decoration: underline;
  color: ${({ theme }) => theme.palette.primary.p080};
  cursor: pointer;
`;
